<template>
	<div class="tl-box">
		<div class="tl-bar">
			<v-tabs v-model="tab" show-arrows height="38" background-color="transparent" class="tl-tabs">
				<v-tab v-for="t in trans" :key="t.lang" class="px-3" :title="t[campo] ? '' : 'Testo vuoto'">
					<v-avatar size="16px" tile class="mr-1"><img :src="bandiera(t.lang)" :alt="t.lang" /></v-avatar>
					{{ String(t.lang).toUpperCase() }}
					<span v-if="!t[campo]" class="tl-dot" />
				</v-tab>
			</v-tabs>
			<div v-if="trans.length > 1" class="tl-actions">
				<v-btn x-small text color="primary" title="Copia il testo della prima lingua in tutte le altre" @click="copia">
					<v-icon left x-small>mdi-content-copy</v-icon>Copia su tutte
				</v-btn>
				<v-btn v-if="traduci" x-small text color="primary" title="Traduci i testi con Google Translate" @click="$emit('traduci')">
					<v-icon left x-small>mdi-translate</v-icon>Traduci
				</v-btn>
			</div>
		</div>
		<div class="tl-body">
			<v-textarea
				v-if="trans[tab] && multiline"
				:key="trans[tab].lang"
				v-model="trans[tab][campo]"
				:label="label + ' ' + String(trans[tab].lang).toUpperCase()"
				:error-messages="errori && errori[tab] ? errori[tab][campo] : ''"
				rows="2"
				auto-grow
				dense
				outlined
				hide-details="auto"
				background-color="white"
			></v-textarea>
			<v-text-field
				v-else-if="trans[tab]"
				:key="trans[tab].lang"
				v-model="trans[tab][campo]"
				:label="label + ' ' + String(trans[tab].lang).toUpperCase()"
				:error-messages="errori && errori[tab] ? errori[tab][campo] : ''"
				dense
				outlined
				hide-details="auto"
				background-color="white"
			></v-text-field>
		</div>
	</div>
</template>

<script>
// testi per lingua a tab compatte: un solo campo visibile, Copia su tutte e Traduci accanto alle tab.
// I valori si scrivono direttamente in trans[i][campo]; la traduzione la fa chi usa il componente.
export default {
	name: 'TestiLinguaTabs',
	props: {
		// [{ lang, <campo> }]
		trans: { type: Array, default: () => [] },
		campo: { type: String, required: true },
		label: { type: String, default: 'Valore' },
		traduci: { type: Boolean, default: true },
		getImageFlag: { type: Function, default: null },
		// errori per lingua, stesso indice di trans: [{ <campo>: 'messaggio' }]
		errori: { type: Array, default: null },
		// testo lungo: area di testo al posto del campo su una riga
		multiline: { type: Boolean, default: false },
	},
	data() {
		return { tab: 0 };
	},
	methods: {
		bandiera(lang) {
			if (this.getImageFlag) return this.getImageFlag(lang);
			try {
				return require(`@/assets/images/flag/${String(lang).toUpperCase()}.svg`);
			} catch (e) {
				return require('@/assets/images/flag/map.svg');
			}
		},
		copia() {
			if (!this.trans.length) return;
			const master = this.trans[0][this.campo];
			this.trans.forEach(t => {
				this.$set(t, this.campo, master);
			});
		},
	},
};
</script>

<style scoped>
.tl-box {
	background: #fff;
	border: 1px solid #e1e7ef;
	border-radius: 8px;
	overflow: hidden;
}
.tl-bar {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	border-bottom: 1px solid #eef2f7;
}
.tl-tabs {
	flex: 1 1 0;
	min-width: 0;
	width: auto;
}
.tl-tabs ::v-deep .v-tab {
	min-width: 0;
	font-size: 12px;
	letter-spacing: 0.03em;
}
.tl-actions {
	display: flex;
	gap: 2px;
	padding: 0 6px;
}
.tl-dot {
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background: #f0a020;
	margin-left: 4px;
}
.tl-body {
	padding: 10px;
}
</style>
